import { Radio } from "@mui/material";
import React from "react";
import { Colors } from "../../Constants/colors";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import {
  ALIGN_ITEMS,
  CURSOR,
  DISPLAY,
  SPACING,
} from "../../Constants/Enums/styles.enum";
import { FontSize } from "../../Constants/Enums/Size.enums";

interface IProps {
  isChecked: boolean;
  label: string;
  onChange: () => unknown;
  name: string;
  value: any;
}

export const RadioButton = ({
  isChecked,
  label,
  onChange,
  name,
  value,
}: IProps) => {
  const handleChange = () => {
    onChange();
  };

  return (
    <label
      style={{
        display: DISPLAY.FLEX,
        alignItems: ALIGN_ITEMS.CENTER,
        gap: SPACING.S8,
        cursor: CURSOR.POINTER,
        fontFamily: FontFamily.ROBOTO_REGULAR,
        fontSize: FontSize.F14,
      }}
    >
      <input
        type="radio"
        name={name}
        checked={isChecked}
        onChange={handleChange}
        value={value}
        style={{
          cursor: CURSOR.POINTER,
          color: Colors.AshRose,
        }}
      />
      {label}
    </label>
  );
};
